import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openModal, analyzeWithAI } from '../redux/aiAnalysis/aiAnalysisSlice'
import { encrypt } from '../utils/encrypt-decrypt'
import useLocale from '../locales'
import { ReactComponent as SparklesIcon } from "../assets/svg/sparkles.svg";
import { aiExplainantionStates } from '../constants/aiExplainantion'

const ExplainWithAI = ({ text = "Analyze with AI", isDisabled = false, calculatorName, className = "" }) => {

    const { activeTab } = useSelector((state) => state.aiAnalysis);
    const { textData } = useLocale()

    const gstVatTabs = {
        "GSTCalc": "gstCalculator",
        "VatCalc": "vatCalculator",
    }

    const sipLumTabs = {
        "sip": "sip",
        "lum": "lum",
    }


    const sliceKeyVal = {
        "personal-loan-calculator": "personalLoanCalculator",
        "fixed-deposit-calculator": "fdCalculator",
        "recurring-deposit-calculator": "rdCalculator",
        "debt-to-income-ratio-calculator": "dtiCalculator",
        "net-worth-calculator": "networthCalculator",
        "loan-payoff-calculator": "earlyLoanCalculator",
        "student-education-loan-calculator": "educationCalculator",
        "credit-card-payoff-calculator": "creditCalculator",
        "business-loan-calculator": "bussinessCalculator",
        "salary-calculator": "salaryCalculator",
        "pension-calculator": "pensionCalculator",
        "car-lease-calculator": "carCalculator",
        "mortgage-loan-refinance-calculator": "mortgageCalculator",
        "401k-retirement-calculator": "contributionCalculator",
        "saving-goal-calculator": "savingsCalculator",
        "loan-to-value-calculator": "ltvCalculator",
        "gst-tax-calculator": gstVatTabs[activeTab] || "gstCalculator",
        "sip-investment-calculator": sipLumTabs[activeTab] || "sip",
    }

    const dispatch = useDispatch()
    const { language, currency, country, numberSystem } = useSelector((state) => state.settings)
    const calcSlice = useSelector((state) => state[sliceKeyVal[calculatorName]])

    const states = aiExplainantionStates[calculatorName]
    const payload = states.reduce((acc, state) => {
        acc[state] = calcSlice[state]
        return acc
    }, {})

    const handleAnalyzeClick = async () => {
        dispatch(openModal())
        const encryptedData = encrypt({
            params: {
                ...payload,
                "calculator_name": calculatorName === "gst-tax-calculator" ? gstVatTabs[activeTab] : calculatorName == "sip-investment-calculator" ? activeTab === "sip" ? "sip/ swp investment calculator" : "lumpsum investment calculator" : calculatorName,
                "language": `${language.value}-${language.label}`,
                "locale_context": country.value,
                "number_system": numberSystem,
                "currency": currency.value,
            },
            iv_key: process.env.REACT_APP_GROWLIFE_CRYPTO_IV_KEY,
            secret_key: process.env.REACT_APP_GROWLIFE_CRYPTO_SECRET_KEY,
        }, process.env.REACT_APP_GROWLIFE_CRYPTO_SECRET_KEY, process.env.REACT_APP_GROWLIFE_CRYPTO_IV, process.env.REACT_APP_GROWLIFE_CRYPTO_ALGORITHM)
        dispatch(analyzeWithAI(encryptedData))
    }

    return (
        <div className={className}>
            <button
                disabled={isDisabled}
                onClick={handleAnalyzeClick}
                className={`relative sm:h-[48px] h-[40px] w-full ${isDisabled ? "opacity-50 pointer-events-none" : "hover:scale-[1.02] transition-transform duration-300"} inline-flex items-center justify-center rounded-full p-[2px] bg-transparent `}
                style={{
                    background: 'linear-gradient(90deg, #EC4899 0%, #BC52C8 50%, #8B5CF6 100%)',
                }}
            >
                <span className='w-full h-full flex items-center justify-center gap-1.5 bg-primary-bg px-6 py-2 rounded-full text-nowrap'>
                    <SparklesIcon className='shrink-0 sm:size-6 size-5' />
                    <span
                        className="flex rounded-full w-fit text-base font-lato-regular-400 text-transparent bg-clip-text"
                        style={{
                            background: 'linear-gradient(88.83deg, #E56489 -2.77%, #AE1595 30.94%, #5230EE 64.9%, #6B55F0 92.76%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                        }}
                    >
                        {textData.aiAnalysis.analyzeWithAI}
                    </span>
                </span>
            </button>

        </div>
    )
}

export default ExplainWithAI
